import Quill from 'quill';

const Clipboard: any = Quill.import('modules/clipboard');
const Delta: any = Quill.import('delta');

// Inline visual formatting that should be stripped from any pasted content.
// Semantic formatting (bold, italic, underline, links, lists, headers, ...)
// is left intact so users keep meaningful structure when copying from elsewhere.
const STRIPPED_ATTRIBUTES = ['background', 'color', 'font', 'size'] as const;

class SanitizingClipboard extends Clipboard {
  constructor(quill: any, options: any) {
    super(quill, options);

    (this as any).addMatcher(Node.ELEMENT_NODE, (_node: HTMLElement, delta: any) => {
      const cleaned = new Delta();
      for (const op of delta?.ops ?? []) {
        if (op.insert == null) continue;
        if (op.attributes) {
          const attrs: Record<string, unknown> = { ...op.attributes };
          for (const key of STRIPPED_ATTRIBUTES) delete attrs[key];
          cleaned.push(
            Object.keys(attrs).length
              ? { insert: op.insert, attributes: attrs }
              : { insert: op.insert }
          );
        } else {
          cleaned.push({ insert: op.insert });
        }
      }
      return cleaned;
    });
  }
}

let registered = false;
export function registerQuillPasteSanitizer(): void {
  if (registered) return;
  Quill.register('modules/clipboard', SanitizingClipboard, true);
  registered = true;
}
